// extracted by mini-css-extract-plugin
export default {"brandPromo":"EH-z","carousel":"FH-z"};